var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "search-item",
            {
              attrs: {
                "config-module": "410",
                "is-append-query": true,
                reset: true,
                "custom-search-items": _vm.customSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Message.QuickSearchBusinessNo"
                )
              },
              on: {
                "click-more": function(value) {
                  _vm.isAdvancedQuery = value
                },
                simSearchItemCallBack: _vm.toSimpleQuery,
                advSearchItemCallBack: _vm.toAdvancedQuery
              }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.selectedRow,
                        no: "new",
                        type: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.toLook()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.look")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.toAdd } },
                    [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.editBtnEnabled,
                        no: "edit",
                        type: "primary"
                      },
                      on: { click: _vm.toEdit }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: !_vm.selectedRow,
                        no: "copy",
                        type: "primary"
                      },
                      on: { click: _vm.toCopy }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        disabled: _vm.rowData.length === 0,
                        no: "delete",
                        type: "danger"
                      },
                      on: { click: _vm.toDelete }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.Delete")))]
                  ),
                  _vm.forecastApproval
                    ? [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.$checkPermission([
                                  "button_Order_submit"
                                ]),
                                expression:
                                  "$checkPermission(['button_Order_submit'])"
                              }
                            ],
                            attrs: { type: "primary", no: "submit" },
                            on: { click: _vm.submitHanlder }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Submit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.$checkPermission([
                                  "button_Order_revoke"
                                ]),
                                expression:
                                  "$checkPermission(['button_Order_revoke'])"
                              }
                            ],
                            attrs: { type: "primary", no: "revoke" },
                            on: { click: _vm.revokeHanlder }
                          },
                          [_vm._v(_vm._s(_vm.$t("Message.Withdraw")))]
                        )
                      ]
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission(["button_Order_accept"]) &&
                            _vm.useOrderCenterMode &&
                            _vm.approveCooperationBusiness,
                          expression:
                            "$checkPermission(['button_Order_accept']) && useOrderCenterMode && approveCooperationBusiness"
                        }
                      ],
                      attrs: { type: "primary", no: "accept" },
                      on: {
                        click: function($event) {
                          return _vm.acceptHandler(0)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("SeaExport.PassAudit")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.$checkPermission(["button_Order_reject"]) &&
                            _vm.useOrderCenterMode &&
                            _vm.approveCooperationBusiness,
                          expression:
                            "$checkPermission(['button_Order_reject']) && useOrderCenterMode && approveCooperationBusiness"
                        }
                      ],
                      attrs: { type: "primary", no: "reject" },
                      on: {
                        click: function($event) {
                          return _vm.rejectHandler(0)
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("SeaExport.Refuse")) + " ")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: ["button_Order_aiReportTransfer"],
                          expression: "['button_Order_aiReportTransfer']"
                        }
                      ],
                      attrs: {
                        disabled: !_vm.selectedRow,
                        type: "primary",
                        no: "forecastApproval"
                      },
                      on: {
                        click: function($event) {
                          _vm.forecastApproval
                            ? _vm.forecastConvertNormal()
                            : _vm.toConvertNormal()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.RegularBusiness")))]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        float: "right",
                        color: "#6666CC",
                        "line-height": "16px"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("queryJob.OrangeWorkingDaysFromETA"))
                      ),
                      _c("br"),
                      _vm._v(_vm._s(_vm.$t("queryJob.RedWorkingDaysFromETA")))
                    ]
                  )
                ],
                2
              )
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { width: "100%" },
                attrs: {
                  "config-module": "210002",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-row-groups": _vm.dataListDragGroup,
                  "darg-group-show-column-def": _vm.dargGroupShowColumnDef
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.appendQuery,
                    expression: "!appendQuery"
                  }
                ],
                attrs: {
                  "config-module": "210002",
                  total: _vm.total,
                  "page-count": _vm.pageCount,
                  page: _vm.pageNum,
                  limit: _vm.pageSize
                },
                on: {
                  "update:page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:limit": function($event) {
                    _vm.pageSize = $event
                  },
                  pagination: _vm.toQuery
                }
              }),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.total, layout: "total" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.cooperationVerifyDialog.visible
        ? _c("cooperation-verify-dialog", {
            attrs: {
              visible: _vm.cooperationVerifyDialog.visible,
              "job-uuid": _vm.cooperationVerifyDialog.jobUuid,
              cooperate: _vm.cooperationVerifyDialog.cooperate,
              "submit-call-back": _vm.cooperationVerifyDialog.submitCallBack,
              editable: _vm.cooperationVerifyDialog.editable
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.cooperationVerifyDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.rejectWindow.visible
        ? _c("reject-dialog", {
            attrs: {
              visible: _vm.rejectWindow.visible,
              "job-no": _vm.rejectWindow.jobNo,
              "reject-call-back": _vm.rejectWindow.rejectCallBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.rejectWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }